import React from 'react';
import { AccountSiteSelect } from '../../../components/AccountSiteSelect';
import { DateRangeBox } from './DateRangeBox';
import { useOperator } from '../../../contexts/OperatorContext';
import { ChangeEvent } from 'react';
import { Switch } from '../../../components/Switch';
import { Card } from '../../../components/Card';
import { CardHeader } from '../../../components/Card/Header';
import { FilterList } from '@material-ui/icons';
import { Select, SelectItem } from '../../../components/Select';
import { SupportTicketCategory } from '../../../types/commonTypes';

interface Props {
  categories: SupportTicketCategory[];
  selectedCategory: string;
  onCategoryChange(category: string): void;
  dateRange: {
    start: Date;
    end: Date;
  };
  pendingOnly: boolean;
  onChange(item: boolean): void;
  setActiveSite(item: any): void;
  setDateRange(item: { start: any; end: any }): void;
  loading: boolean;
}

export const OptionsBar = ({
  categories,
  selectedCategory,
  onCategoryChange,
  dateRange,
  onChange,
  setActiveSite,
  setDateRange,
  loading,
  pendingOnly,
}: Props) => {
  const operator = useOperator();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  const handleSelect = (event: any) => {
    setActiveSite(event);
  };

  return (
    <Card className="flex flex-col !w-full md:!w-[300px] shrink-0">
      <CardHeader
        className="whitespace-nowrap border-b border-border-light dark:border-border-dark"
        startIcon={<FilterList />}
        text="Additional Filters"
        size="sm"
      />
      <div className="flex flex-col gap-2 border-b border-border-light dark:border-border-dark p-4">
        {operator.type === 'Hospitality' &&
        operator.sites &&
        operator.sites.length > 1 ? (
          <AccountSiteSelect
            listAll
            onSelect={handleSelect}
            defaultValue="all"
            disabled={loading}
          />
        ) : null}
        <Select
          label="Category"
          variant="contained"
          fullWidth
          disabled={loading}
          value={selectedCategory}
          onChange={(event) => onCategoryChange(event.target.value)}
        >
          {[
            <SelectItem key="all-categories" value="">
              All categories
            </SelectItem>,
            ...categories.map((category) => (
              <SelectItem key={category.id} value={category.name}>
                {category.name}
              </SelectItem>
            )),
          ]}
        </Select>
        <div className="inline-flex gap-2 items-center justify-between w-full">
          <span>Pending Only</span>
          <Switch
            className="ml-auto"
            disabled={loading}
            checked={pendingOnly}
            onChange={handleChange}
            labelOpacity="default"
            position="end"
          />
        </div>
      </div>
      <DateRangeBox
        disabled={pendingOnly || loading}
        dateRange={dateRange}
        onDateChange={setDateRange}
        quickRange
        showQuickDays
        showQuickToDates
      />
    </Card>
  );
};
